module.exports = __webpack_public_path__ + "img/ir.3a5fd3c5.png";